export const SERVER_URL = "https://mbook.kz";
export const REST_API_URL = "/restapp/";

export const STD_HEADERS = {
    "Accept": "application/json",
    "Content-Type": "application/json",
    "Authorization": document.cookie.match(/sessionid=[A-Za-z0-9]+/) ? document.cookie.match(/sessionid=[A-Za-z0-9]+/)[0] : '',
};

export const FORMDATA_HEADERS = {
    "Accept": "application/json",
    "Authorization": document.cookie.match(/sessionid=[A-Za-z0-9]+/) ? document.cookie.match(/sessionid=[A-Za-z0-9]+/)[0] : '',
};

// export const TEST_HEADER = {
//     "Accept": "application/json",
//     "Content-Type": "application/json",
//     "Authorization": document.cookie.match(/sessionid=[A-Za-z0-9]+/)[0],
//
// };



// WEBPACK FOOTER //
// ./src/settings/production.js